import BaseComponent from "../../../baseComponent.js";
import InternalEvent from "../../../../core/constants/internalEvent.js";
import WidgetService from "../../../../core/services/widgetService.js";
import {TreeMapController} from "./controller";
import styles from './styles.scss';

export default class TreeMapWidget extends BaseComponent {
  constructor(props) {
    super(props);
    this.animationTimeInMillisecond = 1000;
    this.node = null;
    this.componentId = props.componentId;
    this.controller = new TreeMapController(props.componentId, props.legends, this.update);
  }

  componentDidMount() {
    WidgetService.addComponentToWidget(this.props.widgetId, this.controller);
    this.subscribe(InternalEvent.Dashboard.WIDGET_RESIZE, payload => this.handleResize(payload));
    this.subscribe(InternalEvent.Dashboard.WIDGET_RESIZE_STOP, payload => this.handleResizeStop(payload));
  }

  componentWillUnmount() {
    this.unsubscribeAll();
    this.controller.destroy();
  }

  update(data) {
    this.latestData = data;
    const treeMapData = this.prepareData(data);
    if (!this.treemapinitialized) {
      this.initTreemap(treeMapData);
    } else {
      this.updateData(this.root, treeMapData);
      if (!this.onResize) {
        this.renderTreeMap();
      }
    }
  }

  updateData(root, treeMapData) {
    const node = findNode(treeMapData, root.data.name);
    if (node.value) {
      root.data.value = node.value;
    }

    root.children && root.children.forEach((c) => this.updateData(c, treeMapData));

    function findNode(data, name) {
      let node;
      if (data.name === name) {
        node = data;
      }
      data.children && data.children.forEach((c) => {
        let r = findNode(c, name);
        if (r) {
          node = r;
        }
      });
      return node;
    }
  }

  initTreemap(initialData) {
    const container = $(this.refs.treeMapWrapper);
    const width = container.width(),
      height = container.height();
    this.treemap = d3.treemap()
      .size([width, height]);
    this.$root = d3.select(`#${this.props.componentId}`);
    this.root = d3.hierarchy(initialData);
    this.treemapinitialized = true;
    this.renderTreeMap(0);
  }

  renderTreeMap(duration) {

    this.root
      .sum(function (d) {
        return d.value
      })
      .sort(function (a, b) {
        return b.value - a.value;
      });

    this.treemap(this.root);

    const lables = this.$root.selectAll('.node')
      .data(this.root.leaves())
      .enter().append("div")
      .attr("class", "node")
      .append("div")
      .attr("class", "node-label");

    lables.append("div").attr("class", "node-name");
    lables.append("div").attr("class", "node-value");

    this.$root.selectAll('.node')
      .transition()
      .duration(duration == null ? this.animationTimeInMillisecond : duration)
      .attr("title", function (d) {
        this.style.color = d.data.fontColor;
        this.querySelector('.node-name').innerHTML = d.data.name;
        this.querySelector('.node-value').innerHTML = d.value;
        return d.data.name + "\n" + d.value;
      })
      .style("left", function (d) {
        return d.x0 + "px";
      })
      .style("top", function (d) {
        return d.y0 + "px";
      })
      .style("width", function (d) {
        return d.x1 - d.x0 + "px";
      })
      .style("height", function (d) {
        return d.y1 - d.y0 + "px";
      })
      .style("background", function (d) {
        return d.data.color;
      });
  }

  prepareData(rawData) {
    let legends = this.getLegends();
    var data = {
      "name": "cost utilization analysis",
      "children": []
    };

    rawData.forEach((d, index) => {
      let child = {
        name: legends[index].parameters.legendLabel,
        color: legends[index].parameters.legendColor,
        value: d.y || 0
      };

      // todo: make a list of bg colors which needs black font color
      if (child.color === "#FFF200") {
        child.fontColor = "#808080";
      } else {
        child.fontColor = "white";
      }

      data.children.push({
        name: `Legend ${index + 1}`,
        children: [child]
      })
    });
    return data;
  }

  getLegends() {
    const widget = WidgetService.getWidget(this.props.widgetId);
    return widget ? widget.legends : [];
  }

  handleResize(payload) {
    const container = $(this.refs.treeMapWrapper);
    const width = container.width(),
      height = container.height();
    this.treemap = d3.treemap()
      .size([width, height]);
    this.onResize = true;
    this.renderTreeMap(0);
  }

  handleResizeStop() {
    const container = $(this.refs.treeMapWrapper);
    const width = container.width(),
      height = container.height();
    this.treemap = d3.treemap()
      .size([width, height]);
    this.onResize = false;
    this.renderTreeMap(0);
  }

  render() {
    return (
      <div ref="treeMapWrapper" className="tree-map-container"
           style={{width: "100%", marginTop: "35px", height: "calc(100% - 35px)"}}>
        <div id={this.props.componentId} style={{position: 'relative'}}></div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/dashboard/widgets/treeMap/treeMapWidget.jsx